const deepseekTools={
    toolsImg: require("@/assets/icon/deepseek-chat-icon.png"),
        toolsTitle: "DeepSeek-ai",
        toolsTag: "开源基座模型",
        toolsDes:"DeepSeek（深度求索）是一家专注实现AGI（通用人工智能）的中国公司，成立于2023年，其推出的DeepSeek LLM系列大语言模型在多个领域表现出色，尤其在数学、代码和逻辑推理方面具有显著优势。",


        toolsChild:[{
        toolsChildId: 0,
        toolsTitle: "已有开源模型",
        cardList:[
            {
                cardImg:require("@/assets/icon/deepseek-chat-icon.png"),
                cardTitle:"DeepSeek R1",
                cardDes:"强化学习驱动的推理模型",
                cardLink:"https://github.com/deepseek-ai/DeepSeek-R1"
            },
            {
                cardImg:require("@/assets/icon/deepseek-chat-icon.png"),
                cardTitle:"DeepSeek V3",
                cardDes:"深度求索公司自主研发的首款混合专家（MoE）模型，其拥有6710亿参数，激活370亿，在14.8万亿token上完成了预训练。",
                cardLink:"https://github.com/deepseek-ai/DeepSeek-V3"
            },

            {
                cardImg:require("@/assets/icon/deepseek-chat-icon.png"),
                cardTitle:"DeepSeek Coder V2",
                cardDes:"DeepSeek-Coder-V2是一个开源的Mixture-of-Experts（MoE）代码语言模型，它在代码特定任务上能够达到与GPT4-Turbo相媲美的性能。该模型通过在DeepSeek-V2的中间检查点上继续预训练6万亿个标记，显著提升了编码和数学推理能力，同时保持了在通用语言任务上的性能。",
                cardLink:"https://github.com/deepseek-ai/DeepSeek-V3"
            },
            {
                cardImg:require("@/assets/icon/deepseek-chat-icon.png"),
                cardTitle:"DeepSeek Coder VL2",
                cardDes:"高级多模态理解的混合专家（MoE）视觉-语言模型",
                cardLink:"https://github.com/deepseek-ai/DeepSeek-VL2"
            },
        ]
    }],
};
export default deepseekTools;